export class UpdateQuotePartMessage {
  price: number

  constructor(price: number) {
    this.price = price
  }
}
